export const defaultMaxHeight = 686;

export const lifiExplorerUrl = 'https://scan.li.fi';
